import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import React from 'react';

export type GuidanceProps = {
    isGuidanceVisible: boolean;
    from: string;
    onHide: () => void;
};

const Guidance = ({ isGuidanceVisible, onHide, from }: Readonly<GuidanceProps>) => {
    const handleHide = () => {
        onHide();
    };

    return (
        <Dialog
            header={
                <div className="header-coaching mb-3">
                    <h3>Guidelines</h3>
                    <Button
                        type="button"
                        className="btn-primary"
                        label="Return to Strengths"
                        aria-label="Return to Strengths"
                        role="button"
                        onClick={handleHide}
                    />
                </div>
            }
            visible={isGuidanceVisible}
            onHide={handleHide}
            closable={false}
            className="card shadow bg-body rounded mt-4 border-0 p-0 w-65"
            modal
            draggable={false}
            resizable={false}
            style={{
                width: '66vw',
                height: '90vh',
            }}
        >
            <hr />
            <div style={{ fontWeight: 400 }}>
                <p className="m-3">
                    It is important to <b>recognize</b> your employee&rsquo;s strengths. This is a great way
                    to <b>build</b> rapport. Everyone wants to <b>feel valued</b>. This should be a positive
                    message that you arecalling out, so they repeat the same behaviors.
                </p>
                <p className="m-3" style={{ fontWeight: 800 }}>
                    Examples of strengths that should be recognized.
                </p>

                <ul className="m-3" style={{ listStyleType: 'circle' }}>
                    <li>Have they improved in a certain metric?</li>
                    <li>Are they constantly trending in the right direction?</li>
                    <li>Do they go above and beyond for their peers?</li>
                </ul>
                <p className="m-3">
                    As you are having discussions with the employee related to their strengths, ask them if
                    they have any best practices to share in this area. If it makes sense, recommend that the
                    employee share these best practices with their peers.
                </p>
                {from === 'Read' && <>
                    <p className="m-3">
                        <strong>Shout Out Option:</strong>
                    </p>
                    <p className="m-3">
                        Is this worthy of you clicking the shout out button to recognize them? Remember, everyone
                        on the team will see this for 3 days (not months) <br />
                        Ex: thank you so much for consistently having great NPS. You have a 3- month trend. Last
                        month you were… the month before… and this month. <br />
                        Make this very conversational.
                    </p>

                    <p style={{ textAlign: 'right' }}>
                        What gets <b>Rewarded</b> gets <b>Repeated</b> <br /> -Steven Covey
                    </p>
                </>}
            </div>
        </Dialog>
    );
};

export default Guidance;
